import toast from 'react-hot-toast';

export default {
  toastMsg(title, type) {
    toast(title);
  },
  confirm({
    title,
    cancelText = 'Cancel',
    confirmText = 'Confirm',
    cancelFunction,
    confirmFunction,
  }) {},
};
